import type { Holiday } from './types';
import { daysInclusive } from '../../lib/dates';

// Annual-leave days a helper has booked — only `annual` kind draws down the
// allowance (sick/unpaid do not). Derived from the leave entries, not stored.
export function annualDaysUsed(holidays: Holiday[], staffId: string): number {
  return holidays
    .filter((h) => h.staffId === staffId && h.kind === 'annual')
    .reduce((n, h) => n + daysInclusive(h.fromDate, h.toDate), 0);
}

// Is this helper on leave on this date? (Any leave kind — the roster cares that
// they're off, not why.)
export function isOnLeave(holidays: Holiday[], staffId: string | null, dateIso: string): boolean {
  if (!staffId) return false;
  return holidays.some((h) => h.staffId === staffId && h.fromDate <= dateIso && dateIso <= h.toDate);
}

// Leave entries active on each given date — for the week strip / month calendar.
export function leaveByDate(holidays: Holiday[], dates: string[]): Map<string, Holiday[]> {
  const m = new Map<string, Holiday[]>();
  for (const d of dates) {
    m.set(
      d,
      holidays.filter((h) => h.fromDate <= d && d <= h.toDate),
    );
  }
  return m;
}
